<template>
    <div id="current_location_control">
        <a href="#" title="Puntos Cercanos A Mi Localización Actual" @click="CurrentPositionPoints">
            <img src="@/assets/images/current_position.png" />
        </a>
    </div>
</template>
<script>

import { EventBus } from '@/modules/events';

export default {
    'name': "CurrentLocation",
    methods: {
        CurrentPositionPoints() {
            EventBus.$emit("getCurrentPositionPoints");
            return false;
        }
    }
}
</script>
<style lang="scss" scoped>
    
</style>

